/* eslint-disable max-len, no-param-reassign, no-unused-vars */
/**
 * Air theme JavaScript.
 */

import reframe from 'reframe.js';
import './header';

import {
  styleExternalLinks,
  initExternalLinkLabels,
} from './modules/external-link';
import initAnchors from './modules/anchors';
import backToTop from './modules/top';
import initA11ySkipLink from './modules/a11y-skip-link';
import initA11yFocusSearchField from './modules/a11y-focus-search-field';
import {
  navDesktop,
  navMobile,
} from './modules/navigation';

document.body.classList.remove('no-js');
document.body.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  initAnchors();
  backToTop();
  styleExternalLinks();
  initExternalLinkLabels();
  initA11ySkipLink();
  initA11yFocusSearchField();
  navDesktop();
  navMobile();
  reframe('.wp-has-aspect-ratio iframe');

  // Heavy libs only when their markup exists (keeps home JS lean).
  if (document.querySelector('.about-us-gallery')) {
    import('./about-us-gallery');
  }
  if (document.querySelector('.service-projects-slider')) {
    import('./service-project-slider');
  }
  if (document.querySelector('.home-purpose-slider')) {
    import('./purpose-slider');
  }
  if (document.querySelector('.home-projects')) {
    import('./home-mobile-sliders');
    import('./projects-home');
  }

  document.querySelectorAll('.service-video-highlight__video').forEach((videoBox) => {
    const button = videoBox.querySelector('.service-video-highlight__content');
    const videoUrl = videoBox.dataset.videoUrl;

    if (!button || !videoUrl) return;

    button.addEventListener('click', () => {
      videoBox.innerHTML = `
        <iframe
          src="${videoUrl}"
          width="950"
          height="413"
          style="border:none;overflow:hidden"
          scrolling="no"
          frameborder="0"
          allowfullscreen="true"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        ></iframe>
      `;

      videoBox.classList.add('is-playing');
    });
  });
});
